<template>
    <div>
        <div class="card-header">
            <div class="row justify-content-between mb-0 mb-md-4">
                <div class="col-12 col-lg-4">
                    <div class="input-group input-group-sm">
                        <input type="text" name="table_search" class="form-control" placeholder="Buscar" v-model="filters.search"/>

                        <div class="input-group-append">
                            <Button type="submit" variant="default" icon="fas fa-search" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="card-body">
            <template v-for="(event, index) in events.data">
                <div :key="index">
                    <div class="row mb-2">
                        <div class="col-12 col-md-6">
                            <div class="mb-2">
                                <strong>{{ event.codigo }}</strong> -
                                <span v-if="event.status==1" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                                <span v-if="event.status==0" class="mr-2"><i class="text-warning fas fa-pause-circle"></i></span>
                                <span v-if="event.tiene_recinto" class="mr-2"><i class="fas fa-map-marker-alt"></i></span>
                                - {{ event.nombre_completo }}</div>
                        </div>
                        <div class="col-12 col-md-6 text-right">
                            <div>
                                <router-link
                                    :to="{ name: 'back.events.compania', params: { evento_id: event.id}}"
                                    class="btn btn-primary ml-2 margin-bottom-mobile"
                                    v-if="permisos['eventos.editar']"
                                >
                                    <i class="fas fa-users"></i> Compañia
                                </router-link>
                                <router-link
                                    :to="{ name: 'back.events.informe', params: { id: event.id}}"
                                    class="btn btn-primary ml-2 margin-bottom-mobile"
                                    v-if="permisos['eventos.informe']"
                                >
                                    <i class="fas fa-chart-bar"></i> Informe
                                </router-link>
                                <Button type="button" name="button" class="ml-2" @click="expandir(index)" icon="far fa-calendar-alt">Sesiones</Button>

                                <OpcionesDropdownComponent v-if="permisos['eventos.editar']" v-bind:options="[
                                    { to: { name: 'back.events.editar', params: { evento_id: event.id }}, label: 'Editar'},
                                    { type: 'action', action:() => showModal('borrar-' + event.id), label: 'Borrar'},
                                    {
                                        to: {
                                            name: 'back.events.acreditaciones',
                                            params: { evento: event, evento_id: event.id },
                                        },
                                        label: 'Acreditaciones'
                                    },
                                    ...(teatro.invitaciones_para_abonados
                                        ? [
                                            {
                                                to: {
                                                    name: 'back.events.invitaciones-abonados',
                                                    params: { evento_id: event.id },
                                                },
                                                label: 'Invitaciones abonados',
                                            },
                                        ] : []),
                                    ...(permisos['taquilleros.gestion']
                                        ? [
                                            {
                                                to: {
                                                    name: 'back.events.fields',
                                                    params: { evento_id: event.id },
                                                },
                                                label: 'Campos personalizados',
                                            },
                                        ]
                                        : []),
                                ]" class="ml-2"
                                />
                            </div>
                        </div>
                    </div>
                    <DeleteEventModal :evento="event" v-on:close="closeModal"/>
                </div>
                <div
                    :key="'2-' + index"
                    v-show="expand.indexOf(index) >= 0"
                >
                    <div class="row mb-5">
                        <div class="col-12">
                            <button
                                class="float-right btn btn-primary"
                                @click.prevent="showCrearSesion(event)"
                            >
                                Crear sesion
                            </button>
                        </div>
                        <div class="col-12 mt-3">
                            <div>
                                <template v-for="(sesion, index) in event.sesiones">
                                    <div :key="index" class="row mb-2">
                                        <div class="col-12 col-md-2 mb-2"><span v-if="sesion.fecha_provisional==1" class="mr-2"><i class="text-danger fas fa-question-circle"></i></span> {{ sesion.fecha }}</div>
                                        <div class="col-12 col-md-10 text-right">
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.bloquear-asientos',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary" 
                                                v-if="permisos['eventos.editar']"
                                            >
                                                <i class="fas fa-lock"></i> Gestor butacas
                                            </router-link>
                                            <router-link
                                                :to="{ name: 'back.events.venta', params: { evento_id: event.id, sesion_id: sesion.id}}"
                                                class="btn btn-secondary ml-2"
                                                v-if="permisos['eventos.vender']"
                                            >
                                                <i class="fas fa-euro-sign"></i> Venta
                                            </router-link>
                                            <router-link
                                                :to="{ name: 'back.events.ventas', params: { evento_id: event.id, sesion_id: sesion.id}}"
                                                class="btn btn-secondary ml-2"
                                            >
                                                <i class="fas fa-ticket-alt"></i> Listado ventas
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.informe.control-acceso',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2"
                                            >
                                                INFORME CONTROL DE ACCESOS
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.productos',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 "
                                                v-if="permisos['eventos.editar']"
                                            >
                                                Productos
                                            </router-link>
                                            <router-link 
                                                :to="{
                                                    name: 'back.events.sesion.codigos-qr',
                                                    params: { evento_id: event.id, sesion_id: sesion.id },
                                                }" 
                                                class="btn btn-secondary ml-2 "
                                                v-if="permisos['eventos.editar']"
                                            >
                                                Códigos QR
                                            </router-link>
                                            <DescargarInformeControlAcceso name="descargar-informe-control" :evento="event" :sesion_id="sesion.id" :taquillero_id="null" v-on:close="$modal.hide('descargar-informe-control')" />
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="row justify-content-between">
                <div class="col-12 col-lg-3">
                    <ElementosPorPaginaComponent v-model="filters.per_page"/>
                </div>
                <div class="col-12 col-lg-4" v-if="events">
                    <PaginateComponent :current_page="events.meta.current_page" :last_page="events.meta.last_page" v-on:change_page="setPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
    import DeleteEventModal from '@/views/backend/events/modals/DeleteEventModal';
    import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';
    import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
    import DescargarInformeControlAcceso from '../../../views/backend/events/modals/DescargarInformeControlAcceso';

    export default {
        data() {
            return {
                events: { data: [], meta: { current_page: 1 } },
                expand: [],
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    e: 'pasados'
                },
            }
        },
        created() {
            this.debouncedGetEvents = _.debounce(this.getEvents, 500);
            this.getEvents();
        },
        computed: {
            permisos() {
                return this.$store.getters.getPermisos;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        watch : {
            "filters.search"() {
                this.debouncedGetEvents();
            }
        },
        methods: {
            getEvents : function() {
                this.loading = true;
                const data = {
                    filters: this.filters
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                    this.events = res.data;
                }).finally(() => this.loading = false);
            },
            expandir(index) {
                if(this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand.push(index);
                }
            },
            setPage(page) {
                this.filters.page = page;
                this.getEvents();
            },
            showModal(modal) {
                this.expand = [];
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.active_sesion = null;
                this.active_event = null;
                this.$modal.hide(modal);
                if(borrado) {
                    this.getEvents();
                }
            },
        },
        components: {
            PaginateComponent, DeleteEventModal, OpcionesDropdownComponent, ElementosPorPaginaComponent,
            DescargarInformeControlAcceso
        }
    }
</script>

<style scoped>
    @media (max-width: 700px) {
        .margin-bottom-mobile {
            margin-bottom: 10px;
        }
    }
</style>